import { render, staticRenderFns } from "./FormComp.vue?vue&type=template&id=735f80e2"
import script from "./FormComp.vue?vue&type=script&lang=js"
export * from "./FormComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports